// D26 F2 (docs/ticket-detail-2027/02-design/d26-v01.md §5.5 + d26-v02 §3.1 + d26-v03 §1): regimes da tela de tickets.
//  - "Contexto" (.tk-head-ctx): abre/fecha a gaveta do contexto (W < 1297) com data-ctx="aberto" no .tk-detalhe-corpo do MESMO .tk-detalhe.
//    Abrir foca o "×" (.tk-ctx-fechar); "×" ou Esc com o foco dentro da gaveta fecham e devolvem o foco ao "Contexto".
//    A gaveta não é modal (sem armadilha de foco; a conversa continua usável).
//  - "← Fila" (.tk-head-voltar, painel único W < 720): data-tk-painel="fila" na .tk-tela e foco no item marcado. O detalhe fica MONTADO
//    (a guarda de gravação/rascunho do SaidaDetalhe continua valendo). A volta ao detalhe é do FilaSelecao (detalhe chegou) e da exceção
//    R-A no aoClicar do SaidaDetalhe (clique no item já marcado). Este componente NÃO ouve click na captura da window (d26-v03 §1).
//  - Select2 do Tipo dentro da faixa com rolagem lateral (painel único): antes de abrir, a faixa rola até o campo inteiro; rolar a faixa com
//    o dropdown aberto fecha o dropdown (ele não acompanha a rolagem lateral). Rolagem só no `opening`, nunca no focusin (LICOES 43).
// Delegado no document (o detalhe é trocado por replaceContent). Nada aqui chama rede, apaga o detalhe ou mexe no Chats.js.

// DD-04 (docs/oportunidades-2027/02-design/dd04-mapa.md M2/M6): seletores pelo init(opts). Sem opts = os de sempre (Tickets).
const PADRAO = {
    tela: '.tk-tela', detalhe: '.open-ticket-detail', detalheBloco: '.tk-detalhe', corpo: '.tk-detalhe-corpo', ctx: '.tk-ctx',
    ctxBtn: '.tk-head-ctx', conversaBtn: '.tk-head-conversa', ctxFechar: '.tk-ctx-fechar', voltar: '.tk-head-voltar', attrPainel: 'data-tk-painel',
    item: '.tk-item', abrir: '.tk-item-abrir', buscaCampo: '#tk-fila .tk-busca input[type="search"]', faixaDados: '.tk-faixa-dados',
};
let S = PADRAO;

const TelaPaineis = function () {

    const $ = window.jQuery;
    let ativo = false;

    const corpoDe = (el) => {
        const det = el ? el.closest(S.detalheBloco) : null;
        return det ? det.querySelector(':scope > ' + S.corpo) : null;
    };
    const focar = (el, rolar) => { if (el && el.isConnected) el.focus(rolar ? undefined : { preventScroll: true }); };

    // Celular (W < 720, _mobile.scss): "Conversa" visível = a barra é o seletor Conversa | Contexto. Lá o "×" da gaveta não aparece e
    // tocar no lado já ligado não desliga nada.
    const seletor = (el) => {
        const det = el ? el.closest(S.detalheBloco) : null;
        const conversa = det ? det.querySelector(S.conversaBtn) : null;
        return !!conversa && getComputedStyle(conversa).display !== 'none';
    };
    const marcarConversa = (det, ligada) => {
        const conversa = det ? det.querySelector(S.conversaBtn) : null;
        if (conversa) conversa.setAttribute('aria-pressed', ligada ? 'true' : 'false');
    };

    const abrirCtx = (botao) => {
        const corpo = corpoDe(botao);
        if (!corpo) return;
        corpo.setAttribute('data-ctx', 'aberto');
        botao.setAttribute('aria-expanded', 'true');
        marcarConversa(botao.closest(S.detalheBloco), false);
        if (!seletor(botao)) focar(corpo.querySelector(S.ctxFechar), false);
    };
    const fecharCtx = (corpo, focoNoCtx = true) => {
        if (!corpo) return;
        corpo.removeAttribute('data-ctx');
        const det = corpo.closest(S.detalheBloco);
        const botao = det ? det.querySelector(S.ctxBtn) : null;
        marcarConversa(det, true);
        if (botao) { botao.setAttribute('aria-expanded', 'false'); if (focoNoCtx) focar(botao, false); }
    };

    const voltarFila = () => {
        const tela = document.querySelector(S.tela);
        if (!tela) return;
        tela.setAttribute(S.attrPainel, 'fila');
        // Sem preventScroll: o display:none zerou a rolagem da lista, e o foco a leva até o item marcado (d26-v02 §5.3).
        const alvo = document.querySelector(S.item + '[aria-current="true"] ' + S.abrir) || document.querySelector(S.buscaCampo);
        focar(alvo, true);
    };

    const aoClicar = (e) => {
        const alvo = e.target instanceof Element ? e.target : null;
        if (!alvo) return;
        const ctx = alvo.closest(S.ctxBtn);
        if (ctx) {
            const corpo = corpoDe(ctx);
            if (corpo && corpo.getAttribute('data-ctx') === 'aberto') { if (!seletor(ctx)) fecharCtx(corpo); } else abrirCtx(ctx);
            return;
        }
        const conversa = alvo.closest(S.conversaBtn);
        if (conversa) { fecharCtx(corpoDe(conversa), false); return; }
        const fechar = alvo.closest(S.ctxFechar);
        if (fechar) { fecharCtx(fechar.closest(S.corpo)); return; }
        if (alvo.closest(S.voltar)) voltarFila();
    };

    const aoTeclar = (e) => {
        if (e.key !== 'Escape' && e.key !== 'Esc') return;
        // FAIL-H3 (360): um degrau por Esc. Se a escada da SaidaDetalhe (captura) já usou este Esc para fechar a 5ª janela, o foco volta ao
        // olho DENTRO da gaveta antes deste ouvinte rodar (microtarefa entre ouvintes) — sem esta linha a gaveta fechava junto.
        if (e.defaultPrevented) return;
        const a = document.activeElement;
        const ctx = a && a.closest ? a.closest(S.corpo + '[data-ctx="aberto"] > ' + S.ctx) : null;
        if (!ctx) return;
        fecharCtx(ctx.parentElement);
    };

    // ---- Select2 do Tipo na faixa que rola (só quando rola: scrollWidth > clientWidth).
    const rola = (faixa) => !!faixa && faixa.scrollWidth > faixa.clientWidth + 1;
    const ajuste = new WeakMap();   // faixa → scrollLeft que ESTE componente pôs no `opening` (o `scroll` dele chega depois, assíncrono)
    const aoAbrirTipo = (e) => {
        const faixa = e.target.closest ? e.target.closest(S.faixaDados) : null;
        if (!rola(faixa)) return;
        const campo = e.target.closest(S.faixaDados + ' > div');
        if (!campo) return;
        const f = faixa.getBoundingClientRect();
        const c = campo.getBoundingClientRect();
        const antes = faixa.scrollLeft;
        if (c.left < f.left) faixa.scrollLeft -= (f.left - c.left);              // só a faixa: scrollIntoView rolaria os ancestrais
        else if (c.right > f.right) faixa.scrollLeft += (c.right - f.right);
        if (faixa.scrollLeft !== antes) ajuste.set(faixa, faixa.scrollLeft);
    };
    const aoRolar = (e) => {
        const faixa = e.target instanceof Element ? e.target : null;
        if (!faixa || !faixa.matches(S.faixaDados)) return;
        // O `scroll` do próprio ajuste do `opening` não fecha o dropdown que está abrindo; qualquer outra posição fecha.
        if (ajuste.has(faixa)) { const alvo = ajuste.get(faixa); ajuste.delete(faixa); if (faixa.scrollLeft === alvo) return; }
        faixa.querySelectorAll('select.select2-hidden-accessible').forEach((sel) => {
            const c = sel.nextElementSibling;
            if (c && c.classList.contains('select2-container--open') && $ && $.fn && $.fn.select2) $(sel).select2('close');
        });
    };

    return {
        init: function (opts) {
            const s = Object.assign({}, PADRAO, opts || {});   // DD-04: S só muda quando a guarda liga
            if (ativo || !document.querySelector(s.tela) || !document.querySelector(s.detalhe)) return;   // só na tela de tickets nova (ou na do mapa)
            S = s;
            ativo = true;
            document.addEventListener('click', aoClicar);
            document.addEventListener('keydown', aoTeclar);
            document.addEventListener('scroll', aoRolar, true);   // scroll não borbulha: captura
            if ($) $(document).on('select2:opening', S.faixaDados + ' select', aoAbrirTipo);
            // D35 bloco H (J-H7, d35-v20 §4): a 5ª janela fecha a gaveta antes de abrir no regime da gaveta (as duas cobrem a direita)
            window.tkPaineis = { fecharGaveta: () => fecharCtx(document.querySelector(S.corpo + '[data-ctx="aberto"]')) };
        },
    };
}();

module.exports = TelaPaineis;
